import { render, staticRenderFns } from "./Subareas.vue?vue&type=template&id=a30e01bc&scoped=true"
import script from "./Subareas.vue?vue&type=script&lang=js"
export * from "./Subareas.vue?vue&type=script&lang=js"
import style0 from "./Subareas.vue?vue&type=style&index=0&id=a30e01bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30e01bc",
  null
  
)

export default component.exports